import { useHomePageFeature } from '@/hooks/featureFlags';
import { HomePage } from '@/pages/home/HomePage';
import { NotFound } from '@/pages/NotFound';

// Users outside the Home rollout get the same not-found page as any unknown route.
export const HomeFeatureRoute = () => (useHomePageFeature() ? <HomePage /> : <NotFound />);
